import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PricingMethodType } from '../../../model/credits/pricing-method-type';
import { CreditsConfig } from '../../../model/credits/credits-config';

@Component({
  selector: 'gymfinder-credits',
  templateUrl: './credits.component.html',
  styleUrls: ['./credits.component.scss'],
  standalone: false
})
export class CreditsComponent {
  @Input() creditsConfig: CreditsConfig | undefined;
  @Input() editMode: boolean = false;
  @Output() creditsConfigChange = new EventEmitter<CreditsConfig>();

  readonly MIN_PRICE = 0;
  readonly MAX_PRICE = 9999;

  hasError = false;
  errorMessage = '';

  public onPriceChange(value?: number): void {
    if (!this.isValidPrice(value)) {
      this.setError(
        `Price must be between ${this.MIN_PRICE} and ${this.MAX_PRICE}.`
      );
      this.creditsConfigChange.emit(undefined);
      return;
    }
    this.clearError();
    const newCreditsConfig = this.getNewCreditsConfig(value as number);
    this.creditsConfigChange.emit(newCreditsConfig);
  }

  private getNewCreditsConfig(price: number): CreditsConfig {
    return {
      ...this.creditsConfig,
      pricing: [
        {
          price: price,
          priority: 0,
          pricingMethod: { type: PricingMethodType.STANDARD },
        },
      ],
    };
  }

  public get price(): number | undefined {
    return this.creditsConfig?.pricing?.[0]?.price;
  }

  private isValidPrice(value: number | undefined) {
    return (
      typeof value === 'number' &&
      !Number.isNaN(value) &&
      value >= this.MIN_PRICE &&
      value <= this.MAX_PRICE
    );
  }

  private setError(message: string): void {
    this.hasError = true;
    this.errorMessage = message;
  }

  private clearError(): void {
    this.hasError = false;
    this.errorMessage = '';
  }
}
